import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {ArticleDetailService_GetProductDetailsBulkLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.grpc.lazy';
import {GetProductDetailsBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useOptionalSession} from '@aboutyou/user';
import {useProductIdFromSlug} from '../../../features/ProductUrl';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';

const useGetProductDetailsBulkSection = <
  Section extends keyof GetProductDetailsBulkResponse,
>(
  section: Section,
  enabled = true,
) => {
  const productId = useProductIdFromSlug();
  const session = useOptionalSession();

  return useGrpcRequest(
    ArticleDetailService_GetProductDetailsBulkLazy,
    {
      productId: productId!,
      session,
      reductionsState: useReductionsStateRequestParameter(),
      withBasicProductInfoOnly: false,
    },
    {
      keepPreviousData: false,
      section,
      disabled: !enabled,
    },
  );
};

export const useShopTheLookSection = (enabled = true) => {
  return useGetProductDetailsBulkSection('shopTheLookSection', enabled);
};

export const useRatingsAndReviewsSection = (enabled = true) => {
  return useGetProductDetailsBulkSection('reviewSection', enabled);
};
